/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';
import { CreateSurveyQuestionRequest } from '../../models/create-survey-question-request';

export interface CreateSurveyquestion$Plain$Params {
  
    /**
     * properties of new surveyquestion
     */
    body?: CreateSurveyQuestionRequest
}

export function createSurveyquestion$Plain(http: HttpClient, rootUrl: string, params?: CreateSurveyquestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyquestion$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyQuestionModel>;
    })
  );
}

createSurveyquestion$Plain.PATH = '/api/SurveyQuestion';
